/** The most characters of a user name the public chat and overlay show. */
export const USER_NAME_MAX_LENGTH = 12;

const ELLIPSIS = '…';

const segmenter =
  typeof Intl !== 'undefined' && 'Segmenter' in Intl
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : undefined;

// Intl.Segmenter keeps an emoji with its modifiers and joiners in one piece.
// The legacy targets (Chrome 63, Safari 12) lack it; code points still keep
// surrogate pairs whole.
function characters(text: string): string[] {
  if (!segmenter) return Array.from(text);
  return Array.from(segmenter.segment(text), (s) => s.segment);
}

/**
 * Shorten a user name for display, so a long one cannot push the message
 * aside. A name longer than the limit keeps its first characters and ends
 * in an ellipsis, which counts as one of them.
 */
export function displayUserName(
  name: string,
  max = USER_NAME_MAX_LENGTH
): string {
  const chars = characters(name);
  if (chars.length <= max) return name;
  return (
    chars
      .slice(0, max - 1)
      .join('')
      .trimEnd() + ELLIPSIS
  );
}
